exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Bottombg{background-color:#999999;background-size:cover}.navbar .navbar-nav{display:inline-block;float:none;margin:0 auto;text-align:center}.navbar-nav>li{display:inline-block;float:none}.nav.navbar-nav.navbar-bottom-right li a{margin-top:5px;color:white;font-weight:200;font-size:15px;position:relative;cursor:pointer;text-decoration:none}.centerList{text-align:center;margin:0 auto !important}.copyright{margin-top:15px;padding:5px;color:white;font-weight:200;font-size:15px;position:relative}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/Containers/HomeElements/BottomNav.scss
// module id = 1090
// module chunks = 0